import AuthAPI from './authInstance'

const getAll = async (params = {}) => {
  const response = await AuthAPI.get(`/admin/payment/list`, { params })
  return response.data
}

const getOne = async (data) => {
  const response = await AuthAPI.get(`/admin/payment/show/${data}`)
  return response.data
}

export const paymentService = {
  getAll,
  getOne,
}
